<script>
    import {push} from "svelte-spa-router";
    import {_} from "svelte-i18n";
    import {getEntities} from "../../api-client";

    let shLink;
    let shText;
    let shImage;
    export let onSite;

    if (onSite) {
        shLink = "/saalheft/1";
        shText = $_("exhibition_texts_title");
        shImage = "./images/dashboard/Sammlung.png";
    } else {
        shLink = "/highlights";
        shText = $_("highlights_title");
        shImage = "./images/dashboard/highlights2.jpg";
    }

    async function onClick() {
        if (onSite) {
            const saalhefte = await getEntities("saalheft");
            if (saalhefte.length > 0) {
                shLink = "/saalheft/" + saalhefte[0].id;
            }
        }
        push(shLink);
    }
</script>

<div class="rowHighlights">
    <div class="pCursor highlights" on:click={onClick}>
        <img src={shImage} class="mondrian unset imageBlur" alt={shText}/>
        <div class="headline-xs">{shText}</div>
    </div>
    <div class="divider-v div-mondrian pCursor"/>
    <div class="pCursor explore" on:click={() => push("/social")}>
        <img
                src="./images/dashboard/explore.jpg"
                class="explore unset imageBlur"
                alt="#Explore Fondation"
        />
        <div class="headline-xs">
            {$_("explore_tag")}
        </div>
    </div>
</div>
<div>
    <div class="divider-h "/>
</div>

<style>
    .rowHighlights {
        display: flex;
        flex-direction: row;
        margin-top: 22px;
        margin-bottom: 22px;
        width: 100%;
    }

    .mondrian {
        object-fit: cover;
        width: 100%;
        height: 110px;
        margin-bottom: 8px;
        display: block;
    }

    .explore {
        object-fit: cover;
        width: 100%;
        height: 91px;
        margin-bottom: 8px;
        display: block;
    }

    .div-mondrian {
        height: unset;
        align-self: stretch;
        margin-left: 16px;
        margin-right: 16px;
    }

    .highlights {
        width: 100%;
        flex-basis: 58.5%;
    }

    .explore {
        width: 100%;
        flex-basis: 41.5%;
    }

    @media only screen and (min-width: 530px) {
        .mondrian {
            height: 200px;
        }

        .explore {
            height: 170px;
        }
    }

    @media only screen and (min-width: 800px) {
        .rowHighlights {
            margin: 0px;
            margin-bottom: 42px;
        }

        .explore {
            width: 100%;
            height: 170px;
            margin-bottom: 16px;
        }

        .mondrian {
            width: 100%;
            height: 200px;
            margin-bottom: 16px;
        }

        .div-mondrian {
            margin: 0 24px;
        }
    }

    @media only screen and (min-width: 1080px) {
        .mondrian {
            height: 260px;
        }

        .explore {
            height: 215px;
        }
    }

    @media only screen and (min-width: 1728px) {
        .mondrian {
            height: 300px;
        }

        .explore {
            height: 260px;
        }
    }

    @media only screen and (min-width: 1920px) {
        .mondrian {
            height: 330px;
        }

        .explore {
            height: 280px;
        }
    }
</style>
